import { render, staticRenderFns } from "./LedgerHistory.vue?vue&type=template&id=5fb40a76"
import script from "./LedgerHistory.vue?vue&type=script&lang=js"
export * from "./LedgerHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports